import { render, staticRenderFns } from "./inscripcion.vue?vue&type=template&id=70690132&"
import script from "./inscripcion.vue?vue&type=script&lang=js&"
export * from "./inscripcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports